import React, { useEffect } from 'react';
import { useHistory } from 'react-router';

// Types
import { Feature } from 'Shared/types/Organization.type';

// Hooks
import { useFeature } from 'Shared/utils/hooks';

// Components
import ThreeSixtySharePage from '../ThreeSixtySharePage/ThreeSixtySharePage';
import PageUrlsConstants from 'Shared/constants/PageUrls.constants';

const PerformanceReviewSharePage = () => {
  const history = useHistory();
  const { isFreePlan } = useFeature(Feature.performanceReviews);

  // if a free plan, redirect to reviews page to show the feature blocker
  useEffect(() => {
    if (isFreePlan) history.replace(PageUrlsConstants.PERFORMANCE_REVIEWS);
  }, []);

  if (isFreePlan) return null;

  return <ThreeSixtySharePage />;
};

export default PerformanceReviewSharePage;
